/**
 * Action to be taken for the ValueCheckType(1869).
 * tag: 1870
 * @readonly
 * @enum {number} (int)
 */
export enum ValueCheckAction {
  DoNotCheck = 0,
  Check = 1,
  BestEffort = 2,
}
